// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6521":"bbad72e816ed7fa4","7513":"f864a4320b9e7b32"}[chunkId] + ".css";
};